export { default, LoadComponent } from './Loading';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Loading/index.js